module.exports = (__parcel__import__("5S9oZ")).then(() => parcelRequire('emu4l'));